// service-assistant
import moment from 'moment';
import Cookies from 'js-cookie';

import {getApiHost} from './service.js';
import {request as fetch} from './request.js';
import {getParameterByName} from '../utils/tools.js';
import {checkWorkAndGoAeadToNext} from './assistant-work-api.js';

const getCommentHomeworkApiHost = () => {
    if (window.location.hostname.includes('testing')) {
        return 'console.testing.hetao101.com';
    }
    return 'console.hetao101.com';
};

// 获取学生作业列表
const getHomeworkList = homeworkId => {
    const filter = {
        id: homeworkId
    };
    const data = {
        filter: JSON.stringify(filter),
        current: 1, // 页数
        pageSize: 1 // 每页条数
    };
    const getQueryString = function (params) {
        const esc = encodeURIComponent;
        return Object.keys(params)
            .map(k => {
                if (k === 'filter') {
                    return `${esc(k)}=${params[k]}`;
                }
                return `${esc(k)}=${esc(params[k])}`;
            })
            .join('&');
    };

    const url = `//${getApiHost()}/assistant/v1/homeworksByFilter?${getQueryString(data)}`;

    return fetch(url, {
        method: 'get'
    }).then(response => response.json())
        .then(json => {
            if (json.errcode === 0) {
                return json.data;
            }
        });
};

// 获取常用评语列表
const getRemarksList = lessonId => {
    const filter = {
        lessonId: lessonId
    };
    const data = {
        filter: JSON.stringify(filter),
        pageSize: 10, // 每页条数
        current: 1 // 页数
    };
    const getQueryString = function (params) {
        const esc = encodeURIComponent;
        return Object.keys(params)
            .map(k => {
                if (k === 'filter') {
                    return `${esc(k)}=${params[k]}`;
                }
                return `${esc(k)}=${esc(params[k])}`;
            })
            .join('&');
    };

    const url = `//${getApiHost()}/assistant/v1/remarksByFilter?${getQueryString(data)}`;

    return fetch(url, {
        method: 'get'
    }).then(response => response.json())
        .then(json => {
            if (json.errcode === 0) {
                return json.data;
            }
        });
};

// 更改作业状态（批改、忽略、批改中）
const setHomeworkStatus = (correctStatus, id, remarks, score) => {
    const time = moment(new Date()).format('YYYY-MM-DDThh:mm:ss+08:00');
    const teacherId = +getParameterByName('teacherId') || +Cookies.get('userId');

    let data;
    if (correctStatus === 'DONE') {
        data = {
            correctStatus,
            finishtime: time,
            id,
            remarks,
            score,
            teacherId
        };
    } else if (correctStatus === 'IGNORE') {
        data = {
            correctStatus,
            finishtime: time,
            id,
            teacherId
        };
    } else if (correctStatus === 'DOING') {
        data = {
            correctStatus,
            starttime: time,
            id,
            teacherId
        };
    }

    const url = `//${getCommentHomeworkApiHost()}/assistant/v1/homeworks/${data.id}`;
    fetch(url, {
        method: 'PUT',
        body: JSON.stringify(data)
    })
        .then(() => {
            if (correctStatus !== 'DOING') {
                checkWorkAndGoAeadToNext();
            }
        });
};

export {
    getHomeworkList,
    getRemarksList,
    setHomeworkStatus
};
